export const SET_NECKLACE_ORIENTATION = Symbol('SET_NECKLACE_ORIENTATION');
export const SET_BRACELET_ORIENTATION = Symbol('SET_BRACELET_ORIENTATION');
export const SET_CHARM_ORIENTATION = Symbol('SET_CHARM_ORIENTATION');
export const SET_EARRING_QUANTITY = Symbol('SET_EARRING_QUANTITY');
export const SET_EARRING_INPUT = Symbol('SET_EARRING_INPUT');

export const SET_GOLD_COLOR = Symbol('SET_GOLD_COLOR');

export const SET_NECKLACE_LENGTH = Symbol('SET_NECKLACE_LENGTH');
export const SET_BRACELET_LENGTH = Symbol('SET_BRACELET_LENGTH');

export const SET_RING_SIZE = Symbol('SET_RING_SIZE');

export const SET_CHAIN = Symbol('SET_CHAIN');

export const CHANGE_INPUT = Symbol('CHANGE_INPUT');
export const CHANGE_INPUT_2 = Symbol('CHANGE_INPUT_2');

export const LOAD_STATE = Symbol('LOAD_STATE');


export function changeNecklaceOrientation(necklaceOrientation) {
    return {
        type: SET_NECKLACE_ORIENTATION,
        necklaceOrientation,
    }
}

export function changeBraceletOrientation(braceletOrientation) {
    return {
        type: SET_BRACELET_ORIENTATION,
        braceletOrientation,
    }
}

export function changeCharmOrientation(charmOrientation) {
    return {
        type: SET_CHARM_ORIENTATION,
        charmOrientation,
    }
}

export function changeEarringQuantity(earringQuantity) {
    return {
        type: SET_EARRING_QUANTITY,
        earringQuantity,
    }
}

export function changeEarringInput(earringInput) {
    return {
        type: SET_EARRING_INPUT,
        earringInput,
    }
}

export function changeGoldColor(goldColor) {
    return {
        type: SET_GOLD_COLOR,
        goldColor,
    }
}

export function changeChain(chain) {
    return {
        type: SET_CHAIN,
        chain,
    }
}

export function changeNecklaceLength(necklaceLength) {
    return {
        type: SET_NECKLACE_LENGTH,
        necklaceLength,
    }
}

export function changeBraceletLength(braceletLength) {
    return {
        type: SET_BRACELET_LENGTH,
        braceletLength,
    }
}

export function changeRingSize(ringSize) {
    return {
        type: SET_RING_SIZE,
        ringSize,
    }
}

export function changeInput(input) {
    return {
        type: CHANGE_INPUT,
        input,
    }
}

export function changeInput2(input2) {
    return {
        type: CHANGE_INPUT_2,
        input2,
    }
}

export function loadState(state) {
    return {
        type: LOAD_STATE,
        state,
    }
}
